import axios, {
  AxiosError,
  AxiosRequestConfig,
  CreateAxiosDefaults,
} from 'axios';
import stores from '@/store/core/RootStore';
import services from '@/api/services';
import { AuthData } from '@/api/services/AuthService/types';
import router from '@/router';

type ExtendedAxiosRequestConfig =
  | (AxiosRequestConfig & {
      isRetry: boolean;
    })
  | undefined;

const isLocal = window.location.hostname.includes('localhost');

const axiosConfig: CreateAxiosDefaults = {
  baseURL: process.env.VUE_APP_API_URL || '/',
  headers: {
    'Content-Type': 'application/json',
    // 'X-USER-ID': '3bc912ca-9bdf-4ef5-a039-c5d9779f4d9d',
    // 'X-ROLE': 'ADMIN',
  },
  // params: {
  //   ...(isLocal && { local: isLocal }),
  // },
};

const axiosExternalConfig: CreateAxiosDefaults = {
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
    'X-USER-ID': localStorage.getItem("x_user_id") || '7912cb28-12bb-46c5-949f-f28ff47cd5ca',
    'X-ROLE': 'INTEGRATOR',
  },
};

const authAxiosConfig: CreateAxiosDefaults = {
  ...axiosConfig,
  baseURL: process.env.VUE_APP_AUTH_API_URL || '/',
};

export const axiosInstance = axios.create(axiosConfig);
export const axiosExternalInstance = axios.create(axiosExternalConfig);
export const axiosAuthInstance = axios.create(authAxiosConfig);

export const getBearer = (token?: string) => `Bearer ${token || ''}`;

const refresh = async () => {
  const refreshToken: string = stores.userStore.refreshToken || '';
  const response = await services.auth.refresh({ refreshToken });
  return response.data;
};

let isRefreshing: Promise<AuthData> | null = null;

axiosInstance.interceptors.request.use(
  (config) => {
    if (config.headers) {
      config.headers['Authorization'] = getBearer(stores.userStore.token);
    }
    return config;
  },
  (error) => error,
);

axiosExternalInstance.interceptors.request.use(
  (config) => {
    if (config.headers) {
      config.headers['Authorization'] = getBearer(stores.userStore.token);
      config.headers['X-USER-ID'] = localStorage.getItem("x_user_id") || '7912cb28-12bb-46c5-949f-f28ff47cd5ca';
    }
    return config;
  },
  (error) => error,
);

axiosInstance.interceptors.response.use(
  (res) => res,
  async (error: AxiosError) => {
    console.log(error);
    const config = error.config as ExtendedAxiosRequestConfig;
    if (error?.response?.status === 401 && config && !config.isRetry) {
      config.isRetry = true;
      try {
        isRefreshing = isRefreshing ? isRefreshing : refresh();
        const data = await isRefreshing;
        isRefreshing = null;
        stores.userStore.setKey(data);
        return axiosInstance.request(config);
      } catch (error) {
        console.error(error);
        stores.userStore.removeKey();
        await router.push('/auth');
      }
    }
    return Promise.reject(error);
  },
);

export default { axiosInstance, axiosExternalInstance };
